import { i, s, x } from '../../lit-element.js';
import { o } from '../../class-map.js';
import { reset } from '../../styles/reset.style.js';
import { trackAnalyticsEvent } from '../../utils/track-analytics-event.js';
import '../../directive.js';

var img = "data:image/svg+xml,%3csvg width='204' height='32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m103.055 26.038-.354-2.926h-4.69l-1.497 2.926h-1.632l6.254-11.769h1.867l1.648 11.77h-1.596Zm-4.423-4.136h3.917l-.74-6.187-3.177 6.187ZM109.139 17.498l-1.091 5.614c-.045.27-.068.5-.068.69 0 .401.126.717.377.94.251.224.608.334 1.068.334.325 0 .673-.052 1.043-.161a4.233 4.233 0 0 0 1.008-.428l1.362-6.992h1.529l-1.648 8.44-1.262.136v-.574c-.918.529-1.787.79-2.608.79-.75 0-1.345-.2-1.783-.596-.438-.396-.657-.95-.657-1.655 0-.293.029-.567.084-.824l1.11-5.717h1.536v.003ZM118.387 18.605l-.907 4.675c-.055.293-.084.56-.084.808 0 .65.376.975 1.127.975.46 0 .894-.068 1.31-.203l-.219 1.127a4.948 4.948 0 0 1-1.565.25c-.672 0-1.21-.173-1.612-.52-.403-.348-.606-.812-.606-1.394 0-.303.029-.593.084-.873l.94-4.841h-1.226l.202-1.06 1.311-.051.537-2.102 1.362-.167-.438 2.269h2.302l-.219 1.11h-2.299v-.003ZM124.388 26.29c-1.053 0-1.858-.274-2.411-.825-.554-.55-.834-1.345-.834-2.388 0-1.166.196-2.192.589-3.078.393-.885.927-1.564 1.606-2.044a3.926 3.926 0 0 1 2.312-.714c1.052 0 1.857.273 2.411.824.553.55.833 1.345.833 2.388 0 1.166-.196 2.192-.589 3.078-.392.885-.927 1.567-1.606 2.044a3.926 3.926 0 0 1-2.311.715Zm.135-1.21c.56 0 1.049-.2 1.471-.596.419-.396.744-.947.966-1.649.225-.701.335-1.493.335-2.379 0-.682-.145-1.187-.438-1.512-.293-.326-.741-.49-1.346-.49-.56 0-1.049.2-1.471.596-.422.399-.744.946-.966 1.648-.225.702-.335 1.494-.335 2.379 0 .682.145 1.188.438 1.513.29.328.741.49 1.346.49ZM140.763 26.038l-2.086-4.658h-1.899l-.908 4.658h-1.612l2.237-11.514c.447-.113.946-.203 1.497-.27.55-.068 1.068-.1 1.564-.1 1.301 0 2.292.283 2.975.85.682.566 1.027 1.38 1.027 2.446 0 .92-.287 1.7-.857 2.347-.573.643-1.384 1.094-2.437 1.351l2.286 4.893h-1.787v-.003Zm-1.381-10.658c-.55 0-1.043.051-1.48.151l-.892 4.623h1.413c1.098 0 1.954-.235 2.563-.705.611-.47.917-1.127.917-1.967.003-1.404-.837-2.102-2.521-2.102ZM150.025 25.716a5.35 5.35 0 0 1-1.227.422c-.46.1-.908.151-1.345.151-1.121 0-1.98-.299-2.582-.898-.599-.598-.898-1.458-.898-2.581 0-1.088.203-2.057.605-2.907.402-.853.94-1.507 1.606-1.967a3.806 3.806 0 0 1 2.212-.689c.917 0 1.638.248 2.16.74.521.493.782 1.172.782 2.035 0 .605-.113 1.294-.335 2.067h-5.463c-.012.135-.022.27-.032.412a4.449 4.449 0 0 0-.016.412c0 1.445.741 2.17 2.218 2.17.448 0 .898-.049 1.352-.142a5.859 5.859 0 0 0 1.201-.38l-.238 1.155Zm-1.716-7.346c-.605 0-1.13.229-1.571.69-.444.46-.769 1.104-.985 1.934h4.053c.067-.325.1-.644.1-.96 0-.55-.136-.962-.403-1.245-.267-.277-.666-.419-1.194-.419ZM152.581 26.038l1.445-7.43H152.8l.202-1.058 1.243-.052.354-1.816c.167-.85.493-1.5.975-1.95.483-.448 1.111-.673 1.884-.673.437 0 .878.097 1.329.286l-.203 1.043a2.933 2.933 0 0 0-.924-.15c-.402 0-.74.128-1.007.385-.271.258-.448.628-.538 1.111l-.354 1.764h2.17l-.219 1.11h-2.15l-1.446 7.43h-1.535Zm5.26 0 1.632-8.389 1.564-.183-1.664 8.572h-1.532Zm2.826-10.288c-.28 0-.502-.07-.663-.21a.735.735 0 0 1-.245-.579c0-.357.103-.64.313-.85.206-.206.489-.312.849-.312.28 0 .503.071.664.21.16.141.244.334.244.579 0 .36-.103.64-.312.85-.209.206-.493.312-.85.312ZM166.954 26.038l1.091-5.614c.045-.27.068-.499.068-.689 0-.415-.129-.73-.386-.95-.258-.218-.635-.328-1.127-.328-.325 0-.673.055-1.043.161-.37.107-.705.251-1.008.429l-1.361 6.991h-1.529l1.648-8.44 1.262-.135v.573c.917-.528 1.786-.789 2.607-.789.795 0 1.413.2 1.848.596.438.399.657.95.657 1.654 0 .293-.029.567-.084.824l-1.111 5.717h-1.532ZM175.829 26.07v-.573c-.921.529-1.786.79-2.607.79-.773 0-1.388-.213-1.842-.638-.454-.425-.682-1.005-.682-1.732 0-.583.154-1.095.463-1.539a3.038 3.038 0 0 1 1.253-1.027c.528-.241 1.113-.36 1.764-.36.74 0 1.513.1 2.321.302l.167-.875c.032-.203.052-.38.052-.538 0-.47-.165-.827-.496-1.069-.332-.241-.811-.36-1.439-.36-.985 0-1.883.164-2.691.49l.219-1.144a7.076 7.076 0 0 1 2.791-.553c.998 0 1.767.212 2.311.637.544.425.814 1.027.814 1.8 0 .302-.029.582-.083.84l-1.059 5.414-1.256.136Zm-2.034-.975c.347 0 .705-.051 1.075-.16a3.9 3.9 0 0 0 1.007-.445l.422-2.202a7.777 7.777 0 0 0-1.848-.219c-.695 0-1.229.148-1.606.444-.377.297-.563.725-.563 1.285 0 .866.505 1.297 1.513 1.297ZM184.62 26.038l1.092-5.614c.045-.27.067-.499.067-.689 0-.415-.128-.73-.386-.95-.257-.218-.634-.328-1.127-.328-.325 0-.672.055-1.043.161a4.36 4.36 0 0 0-1.007.429l-1.362 6.991h-1.529l1.648-8.44 1.262-.135v.573c.918-.528 1.787-.789 2.608-.789.795 0 1.413.2 1.847.596.438.399.657.95.657 1.654 0 .293-.029.567-.084.824l-1.11 5.717h-1.533ZM194.407 25.716a5.972 5.972 0 0 1-2.54.573c-2.118 0-3.178-1.171-3.178-3.512 0-1.088.203-2.053.606-2.9.402-.847.949-1.497 1.638-1.95a4.083 4.083 0 0 1 2.295-.68c.841 0 1.629.219 2.37.657l-.203 1.143c-.66-.38-1.339-.573-2.035-.573-.885 0-1.619.402-2.201 1.21-.583.808-.876 1.825-.876 3.058 0 .83.158 1.423.47 1.783.312.358.824.538 1.529.538.348 0 .728-.045 1.143-.135.415-.09.817-.22 1.21-.387l-.228 1.175ZM202.29 25.716c-.357.18-.769.32-1.226.422-.461.1-.908.151-1.346.151-1.12 0-1.98-.299-2.582-.898-.598-.598-.898-1.458-.898-2.581 0-1.088.203-2.057.605-2.907.403-.853.94-1.507 1.607-1.967a3.8 3.8 0 0 1 2.211-.689c.918 0 1.639.248 2.16.74.522.493.783 1.172.783 2.035 0 .605-.113 1.294-.335 2.067h-5.463c-.013.135-.023.27-.035.412a4.456 4.456 0 0 0-.017.412c0 1.445.741 2.17 2.218 2.17.448 0 .899-.049 1.352-.142a5.84 5.84 0 0 0 1.201-.38l-.235 1.155Zm-1.716-7.346c-.605 0-1.129.229-1.57.69-.445.46-.77 1.104-.982 1.934h4.053c.067-.325.099-.644.099-.96 0-.55-.135-.962-.402-1.245-.274-.277-.67-.419-1.198-.419Z' fill='%23013D5B'/%3e%3cpath d='M60.498 23.141c-.003.003-.006.007-.013.01-3.795 2.688-8.292 5.51-13.127 8.473l-.19.112a.147.147 0 0 0-.036.203c.045.064.136.08.2.035l.16-.083a732.87 732.87 0 0 0 13.557-7.292c.025-.012.051-.029.077-.041a5.872 5.872 0 0 1-.628-1.417ZM85.411 2.973c-5.984-6.599-44.482-.663-60.854 2.914l-.38.083a.148.148 0 0 0-.12.168c.014.08.088.132.168.119l.38-.074c13.562-2.414 41.771-5.762 47.84.254 1.85 1.835 1.41 4.201-.738 6.992 1.159.744 1.983 1.912 2.353 3.377 8.383-5.576 14.016-10.89 11.35-13.833Z' fill='%23CC2427'/%3e%3cpath d='M10.576 21c-1.184.235-1.848.326-3.02.326-1.738 0-3.115-.863-3.041-2.444.051-1.052 1.3-3.274 4.47-3.274.999 0 1.778.178 2.827.776l.46-2.585c-1.425-.54-2.369-.621-3.595-.605C4.524 13.24.533 15.13.037 18.97c-.502 3.902 4.262 4.884 6.38 4.874a37.393 37.393 0 0 0 3.676-.177L10.576 21ZM18.238 20.237c-.161.062-.37.123-.628.174-.258.058-.728.142-1.41.251-.47.074-.795.174-.982.306-.177.132-.283.29-.312.48a.468.468 0 0 0 .206.496c.18.125.483.19.908.19.318 0 .634-.052.936-.149.306-.1.567-.238.767-.405.144-.126.25-.287.328-.48.045-.125.11-.412.187-.863Zm3.92-2.436c-.016.363-.077.682-.177 1.239l-.663 3.721c-.058.332.065.59.374.766l-.02.145-3.798-.006-.035-.947a7.449 7.449 0 0 1-1.826.78 6.641 6.641 0 0 1-1.819.222c-1.226 0-1.928-.13-2.414-.554-.492-.438-.73-.73-.708-1.333.02-.348.2-.792.46-1.104.264-.316.621-.525 1.011-.705.393-.187.853-.322 1.523-.428.672-.11 1.606-.22 2.858-.322a4.089 4.089 0 0 0 1.25-.283c.26-.103.363-.213.402-.428.07-.384-.052-.602-.56-.702-1.369-.27-3.934.174-5.254.505l.718-1.938c1.741-.254 3.377-.418 5.096-.418 2.733.006 3.608.788 3.582 1.79ZM28.355 17.98c-.476 0-.907.146-1.29.432-.38.29-.622.712-.718 1.275-.116.65-.049 1.114.209 1.404.26.286.634.428 1.123.428.332 0 .673-.058.924-.184.312-.164.525-.338.712-.611.2-.29.331-.609.399-.982.103-.586.016-1.027-.258-1.317-.26-.3-.624-.444-1.1-.444Zm-6.618 8.264 1.77-9.97h3.194l-.248 1.272c.277-.38.72-.692 1.33-.946.614-.251 1.31-.438 2.063-.438.834 0 1.349.045 1.97.367.621.325 1.052.795 1.287 1.41.239.605.29 1.285.161 2.025-.215 1.23-.814 2.199-1.796 2.91-.975.711-1.85.898-3.103.905-.444 0-.814-.046-1.123-.123a2.527 2.527 0 0 1-.725-.29c-.174-.119-.36-.28-.599-.54l-.595 3.418h-3.586ZM33.165 23.675l1.316-7.439h3.635l-1.317 7.44h-3.634Zm1.52-9.161c.108-.612 1.074-1.107 2.153-1.107 1.078 0 1.867.495 1.764 1.107-.113.612-1.079 1.107-2.157 1.107-1.085 0-1.87-.495-1.76-1.107ZM40.124 16.194l.261-1.513 3.802-.827-.406 2.344h1.864l-.354 1.496-1.806-.003-1.098 5.981s-3.66-.022-3.673 0l1.095-5.968h-1.381l.28-1.51h1.416ZM51.034 20.257a6.516 6.516 0 0 1-.631.174c-.254.06-.724.135-1.413.247-.467.075-.799.174-.979.306a.769.769 0 0 0-.315.48c-.039.206.035.37.209.496.184.125.49.186.914.186.316 0 .628-.048.934-.145a2.32 2.32 0 0 0 .77-.405c.137-.126.247-.29.321-.483.045-.125.11-.412.19-.856Zm3.918-2.444c-.017.364-.08.686-.18 1.24l-.66 3.728c-.059.328.064.585.37.769l-.023.129-3.795.006-.03-.95a7.552 7.552 0 0 1-1.824.78 6.56 6.56 0 0 1-1.826.225c-1.226 0-1.922-.122-2.408-.55-.495-.442-.733-.728-.708-1.33.013-.351.197-.798.457-1.104.264-.322.622-.525 1.014-.709.393-.183.857-.321 1.517-.43a42.115 42.115 0 0 1 2.865-.323 4.31 4.31 0 0 0 1.239-.273c.264-.103.37-.216.409-.432.067-.376-.052-.598-.557-.701-1.375-.27-3.934.173-5.254.502l.715-1.938c1.751-.255 3.377-.419 5.096-.419 2.733-.003 3.605.782 3.583 1.78ZM58.644 23.669l-3.705.006 1.864-10.378 3.608.103-1.767 10.269ZM62.919 21.41c.077 2.32 1.545 4.223 3.464 4.223 3.715 0 5.292-4.558 5.182-7.607-.077-2.327-1.587-4.223-3.499-4.223-3.196 0-5.257 4.538-5.147 7.606Zm-1.964-.126c-.138-3.963 2.968-8.016 7.478-8.016 3.016 0 4.99 2.009 5.1 5.086.144 4.179-2.756 8.016-7.479 8.016-3.013.003-4.99-2.002-5.099-5.086Z' fill='%23013D5B'/%3e%3cpath d='M73.478 18.808c.25-.032.66-.077.833-.077.267 0 .519.051.531.315.007.158-.28 1.288-.338 1.549l-.566 2.501a87.734 87.734 0 0 1-.699 2.942h1.459l.817-3.962c2.498-2.605 3.46-3.451 4.05-3.451.264 0 .447.138.46.457.016.457-.27 1.497-.367 1.796l-.837 2.89c-.19.651-.331 1.234-.318 1.655.025.635.408.918.978.918 1.066 0 1.838-1.11 2.514-2.199l-.196-.357c-.274.438-.905 1.394-1.404 1.394-.157 0-.305-.106-.312-.37-.016-.338.129-.844.225-1.179l.928-3.386c.248-.934.367-1.532.36-1.851-.022-.631-.392-.927-.956-.927-.96 0-2.23.698-4.925 3.801h-.039l.338-1.512c.184-.828.364-1.69.541-2.29-.93.335-2.27.712-3.094.873l.017.47Z' fill='%23013D5B'/%3e%3cpath d='M87.748 18.892c-.02-.599-.322-1.001-.94-1.001-1.49 0-3.078 2.92-3.351 4.098 2.446 0 4.349-1.455 4.29-3.097Zm.319 4.58.286.197c-.727 1.48-2.211 2.675-3.95 2.675-1.423 0-2.588-.946-2.652-2.727-.116-3.186 2.871-6.148 5.318-6.148 1.05 0 2.021.457 2.066 1.587.09 2.537-3.47 3.31-5.813 3.364-.078.264-.107.531-.09.937.038 1.052.675 1.934 1.989 1.934 1.136-.003 2.273-.917 2.846-1.818Z' fill='%23013D5B'/%3e%3c/svg%3e";
  var logo = img;

const style = i`
  :host {
    box-sizing: border-box;
    display: block;
    min-height: 4em;
    position: sticky;
    top: 0;
    z-index: 799;
  }

  :host([hidden]) {
    display: none;
  }

  header {
    background-color: #10253f;
    box-sizing: border-box;
    min-height: 4em;
    padding-top: 0.5em;
    width: 100%;
  }

  header.borderless {
    border-bottom: none;
  }

  header::after {
    clear: both;
    content: ' ';
    display: block;
    height: 0;
    visibility: hidden;
  }

  .container {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 1fr auto 1fr;
    grid-template-columns: 1fr auto 1fr;
    min-height: 4em;
  }

  @media (min-width: 48em) {
    .container {
      margin: 0 auto;
      max-width: 48em;
    }
  }

  @media (min-width: 60em) {
    .container {
      max-width: 60em;
    }
  }

  .center {
    align-self: center;
    cursor: pointer;
    display: block;
    -ms-grid-column: 2;
    grid-column: 2 / 3;
    -ms-grid-column-align: center;
    -ms-grid-column-span: 1;
    -ms-grid-row-align: center;
    justify-self: center;
  }

  .center h1 {
    line-height: 0;
  }

  .center a {
    display: block;
  }

  .center svg {
    height: 2em;
    width: auto;
  }

  @media (min-width: 48em) {
    .center svg {
      height: 2.5em;
    }
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .center {
      min-height: 4em;
    }

    .center h1 {
      padding-top: 0.5em;
    }
  }

  .left-slot {
    align-self: center;
    -ms-grid-column: 1;
    grid-column: 1 / 2;
    -ms-grid-column-align: start;
    -ms-grid-column-span: 1;
    -ms-grid-row-align: center;
    justify-self: left;
  }

  .right-slot {
    align-self: center;
    -ms-grid-column: 3;
    grid-column: 3 / 4;
    -ms-grid-column-align: end;
    -ms-grid-column-span: 1;
    -ms-grid-row-align: center;
    justify-self: right;
    padding-right: 0.625em;
  }

  .bottom-slot {
    grid-column: 1 / -1;
    -ms-grid-column-align: start;
    -ms-grid-row: 2;
    -ms-grid-row-align: center;
  }

  .st0 {
    fill: #b5121b;
  }

  .st1 {
    fill: #005288;
  }

  .st2 {
    fill: #3f4d55;
  }
`;

// const logo = new URL('../../../node_modules/@cof/fs-logos/lib/logo-fs-auto-refinance-primary-full-color.svg', import.meta.url).href;
class RefiHeader extends s {
  constructor() {
    super();
    this.isProd = !window.location.href.includes('cloud');
    this.showBanner = false;
    this.hideLogo = false;
  }

  static get properties() {
    return {
      borderless: { type: Boolean, attribute: true },
      showBanner: { type: Boolean, reflect: true },
      hideLogo: { type: Boolean, attribute: 'hide-logo' },
    };
  }

  static get styles() {
    return [reset, style];
  }

  render() {
    return x`
      <header class="${o({ borderless: this.borderless })}">
        <div class="container">
          <div class="left-slot">
            <slot name="left-slot"></slot>
          </div>
          <div class="center">
            <h1 ?hidden="${this.hideLogo}">
              <a href="https://${this.isProd ? 'www.capitalone.com' : 'wwwbeta.capitalone.com'}/auto-financing/refinance" aria-label="Capital One Auto Refinance" @click="${this.clearSession}">
                <img src="${logo}" alt="Logo" />
              </a>
            </h1>
          </div>
          <div class="right-slot">
            <slot name="right-slot"></slot>
          </div>
          <div class="bottom-slot">
            <refi-common-banner ?hidden="${!this.showBanner}" @bannerReady="${this.bannerReady}" class="header-banner"></refi-common-banner>
          </div>
          <slot></slot>
        </div>
      </header>
    `;
  }

  bannerReady() {
    this.showBanner = true;
    this.requestUpdate(this.querySelector('.header-banner'));
  }

  clearSession() {
    trackAnalyticsEvent('refi-logo-clicked');
    if (sessionStorage.getItem('auto-refi-session')) {
      sessionStorage.removeItem('auto-refi-session');
    }
    if (sessionStorage.getItem('iv-session-id')) {
      sessionStorage.removeItem('iv-session-id');
    }
  }
}

export { RefiHeader };
